import { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import StepHeader from "@/components/StepHeader";

function renderLegalLine(line, index) {
  if (!line.trim()) return null;
  if (index === 0) return <h1 key={index} data-testid="privacy-terms-title">{line}</h1>;
  if (/^(Promoter:|Contest Period:|Contest Page:|No purchase necessary)/i.test(line)) return <p className="legal-emphasis" key={index}>{line}</p>;
  if (/^[A-Z][A-Za-z\s,&’'()/-]+$/.test(line) && line.length < 90) return <h2 key={index}>{line}</h2>;
  if (/^(Stage \d|Contact)$/i.test(line)) return <h3 key={index}>{line}</h3>;
  if (/^[•*-]\s/.test(line)) return <li key={index}>{line.replace(/^[•*-]\s*/, "")}</li>;
  return <p key={index}>{line}</p>;
}

export default function PrivacyTermsPage() {
  const [content, setContent] = useState("");
  useEffect(() => {
    fetch("/privacy-terms.md").then((response) => response.text()).then(setContent).catch(() => setContent("Terms content could not be loaded."));
  }, []);

  return (
    <main className="legal-page" data-testid="privacy-terms-page">
      <StepHeader compact progressLabel="Privacy & Terms" />
      <section className="legal-shell" data-testid="privacy-terms-shell">
        <Link className="ghost-btn" to="/" data-testid="privacy-terms-back-home-link"><ArrowLeft size={16} /> Back to Fit Check</Link>
        <article className="legal-content" data-testid="privacy-terms-content">
          {content.split(/\n+/).map(renderLegalLine)}
        </article>
      </section>
    </main>
  );
}